export const locales = ["en", "fr", "de", "am", "ti", "sw", "ar", "om", "so"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "en";

export const localeLabels: Record<Locale, string> = {
  en: "English",
  fr: "Français",
  de: "Deutsch",
  am: "አማርኛ",
  ti: "ትግርኛ",
  sw: "Kiswahili",
  ar: "العربية",
  om: "Afaan Oromoo",
  so: "Soomaali",
};

export const LOCALE_COOKIE = "edaga-locale";

const rtlLocales: readonly Locale[] = ["ar"];

export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}

export function localeDirection(value: string): "ltr" | "rtl" {
  return isLocale(value) && rtlLocales.includes(value) ? "rtl" : "ltr";
}
